import {NgModule, Pipe, PipeTransform} from '@angular/core';
import { ShareDataService } from '@signature-it/ngx-generic/services';

@Pipe({
    name: 'removeModeElements',
    standalone: false
})
export class RemoveModeElementsPipe implements PipeTransform {
    constructor(public shareDataService: ShareDataService) {}

    transform(value: string): string{
        const parser = new DOMParser();
        const doc = parser.parseFromString(value, 'text/html');

        // Find and remove elements with the userLogin attribute
        const elementsDesktop = doc.querySelectorAll('[Desktop]');
        const elementsMobile = doc.querySelectorAll('[Mobile]');

         if (this.shareDataService.isMobileMode()) {
             elementsDesktop.forEach(element => element.remove());
             return doc.body.innerHTML;
         } else {
             elementsMobile.forEach(element => element.remove());
             return doc.body.innerHTML;
         }
    }
}
@NgModule({
    declarations: [RemoveModeElementsPipe],
    exports: [RemoveModeElementsPipe]
})
export class  RemoveModeElementsPipeModule{}

